import moment from 'moment'

import { getPortalBaseUrl } from 'utils/domain-urls'

export const generateUrl = (
  preview: any,
  tab: number,
  merchantData: any,
  merchantName?: string
) => {
  // TODO: Branch de implementação
  // let url = `https://portal-git-epic-sc-5686-client-base.vercel.app/preview?tab=${tab}&product_due_date=${moment().format(
  //   'DD/MM/yyyy'
  // )}`
  // TODO: Branch de Local
  // let url = `http://localhost:3001/preview?tab=${tab}&product_due_date=${moment().format(
  //   'DD/MM/yyyy'
  // )}`
  let url = `${getPortalBaseUrl()}/preview?tab=${tab}&is_preview=true&product_due_date=${moment().format(
    'DD/MM/yyyy'
  )}`

  if (preview?.product_uuid) {
    url += `&product_uuid=${preview?.product_uuid}`
  }

  if (merchantName) {
    url += `&merchant_name=${merchantName}`
  }

  if (merchantData?.primary_color) {
    url += `&primary_color=${(merchantData?.primary_color as string).replace(
      '#',
      ''
    )}`
  }

  if (merchantData?.font_color) {
    url += `&secondary_color=${(merchantData?.font_color as string).replace(
      '#',
      ''
    )}`
  }

  if (merchantData?.logo) {
    url += `&merchant_logo=${merchantData?.logo as string}`
  }

  if (preview?.product_description) {
    url += `&product_description=${encodeURIComponent(
      preview?.product_description.replace(/\r?\n/g, '\r\n')
    )}`
  }

  if (preview?.extra_fields) {
    url += `&extra_fields=${preview?.extra_fields}`
  }

  if (preview?.title) {
    url += `&title=${preview?.title}`
  }

  if (preview?.description) {
    url += `&description=${encodeURIComponent(
      preview?.description.replace(/\r?\n/g, '\r\n')
    )}`
  }

  if (preview?.product_amount) {
    url += `&product_amount=${preview?.product_amount}`
  }

  if (preview?.product_name) {
    url += `&product_name=${preview?.product_name}`
  }

  if (preview?.product_icon) {
    url += `&product_icon=${preview?.product_icon || 'add'}`
  }

  if (preview?.interest_fee) {
    url += `&interest_fee=${preview?.interest_fee}`
  }

  if (preview?.interest_fine) {
    url += `&interest_fine=${preview?.interest_fine || ''}`
  }

  if (preview?.discounts_days_1 && preview?.discounts_amount_1) {
    url += `&discounts_days_1=${preview?.discounts_days_1}&discounts_amount_1=${preview?.discounts_amount_1}`
  }

  if (preview?.discounts_days_2 && preview?.discounts_amount_2) {
    url += `&discounts_days_2=${preview?.discounts_days_2}&discounts_amount_2=${preview?.discounts_amount_2}`
  }

  if (preview?.interest_policy) {
    url += `&interest_policy=${preview?.interest_policy}`
  }

  if (preview?.payment_type) {
    url += `&payment_type=${preview?.payment_type}`
  }

  if (preview?.image) {
    url += `&image=${preview?.image}`
  }

  // Novos parâmetros para API v3
  if (preview?.billing_items) {
    url += `&billing_items=${encodeURIComponent(preview?.billing_items)}`
  }

  if (preview?.custom_field_configs) {
    url += `&custom_field_configs=${encodeURIComponent(
      preview?.custom_field_configs
    )}`
  }

  return url
}
